<div class="section">
  <div class="row pagetitle-row">
    <div class="pagetitle">
      <div class="nav-icons chapters">
        <i class="fa fa-chevron-up fa-2x" aria-hidden="true"></i>
      </div>
      <h1 class="chapters">Section Title goes here...</h1>
    </div>
  </div>

  <form
    class="full-width"
    novalidate="novalidate"
    (ngSubmit)="save()"
    [formGroup]="chapterForm">
    <h3>Component1</h3>

    <p>
      For ACEP chapter membership, a person must be a member of the College,
      live or work in the state/territory/district represented by the chapter,
      and pay the chapter dues for each chapter membership. Chapters advocate
      for physicians' rights and their patients to ensure the highest quality
      emergency care. Visit
      <a
        href="https://www.acep.org/chapters"
        title="ACEP Chapter's page"
        target="_blank">ACEP Chapter's page</a>
      for more information.
    </p>
    <div class="row row-padding-topbottom-40">
      <div formArrayName="chapters">
        <div
          *ngFor="let chp of chapterFormArray.controls; let idx= index"
          [formGroupName]="idx"
          class="chapter">
          <div class="col-xs-6 col-md-3">
            <div
              class="thumbnail {{chp.get('code').value}}
              {{chp.get('selected').value}}">
              <div class="thumbheader">
                <mat-checkbox
                  formControlName="selected"
                  #selected></mat-checkbox>
                {{ chp.get("name").value }}
              </div>
              <div class="thumbbody">
                <div class="state">
                  <div
                    class="state-icon {{chp.get('code').value}} preview"></div>
                </div>
                <div class="primarybox">
                  <mat-radio-button
                    color="primary"
                    [disabled]="!chp.get('selected').value"
                    [value]="chp.get('id').value"
                    (change)="changePrimary($event)"
                    [checked]="chp.get('isPrimary').value">Primary Chapter</mat-radio-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--
        <div class="col-xs-6 col-md-3">




          <div class="thumbnail">





            <div class="thumbheader">





              <mat-checkbox color="primary"></mat-checkbox>





              Florida College of Emergency Physicians





            </div>





            <div class="state">





              <div class="FL preview"></div>





            </div>






            <div class="primarybox">





              <mat-radio-button color="primary" value="1">Primary Chapter</mat-radio-button>





            </div>






          </div>





        </div>
      -->
    </div>

    <button type="button" mat-raised-button="mat-raised-button" class="greyBtn"
      (click)="getQuote()">
      Get Quote
    </button>


    <button
      type="button"
      mat-raised-button="mat-raised-button"
      class="greyBtn"
      (click)="chapterChange()">
      Change Chapter
    </button>

    <div class="row actions">
      <div class="col-md-12">
        <button mat-raised-button="mat-raised-button" class="btnSave">
          Save and Continue
        </button>
      </div>
    </div>
  </form>

  <pre *ngIf="isDevEnv">
    <code>{{chapterForm.value | json}}</code>
  </pre>
</div>
